module.exports = __webpack_public_path__ + "img/Jump Casting91.e19e4913.jpg";